import DotNetObject = DotNet.DotNetObject;

export const GuidService = (() => {
  let dotNetObj: DotNetObject;

  const setDotNetReference = (obj: DotNetObject): void => {
    dotNetObj = obj;
  };

  const generateGuid = async (): Promise<string> => {
    if (dotNetObj) {
      return await dotNetObj.invokeMethodAsync<string>('GenerateGuid');
    } else {
      throw 'Guid DotNet Object Reference has not yet been implemented';
    }
  };

  return {
    setDotNetReference,
    generateGuid,
  };
})();